import { render, staticRenderFns } from "./ElectrodeFixOne.vue?vue&type=template&id=944e94b4&scoped=true"
import script from "./ElectrodeFixOne.vue?vue&type=script&lang=js"
export * from "./ElectrodeFixOne.vue?vue&type=script&lang=js"
import style0 from "./ElectrodeFixOne.vue?vue&type=style&index=0&id=944e94b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944e94b4",
  null
  
)

export default component.exports